import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Header } from '@/components/Header';
import '@/index.css';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
import HomePage from '@/pages/HomePage';
import BookingPage from '@/pages/BookingPage';
import ConfirmationPage from '@/pages/ConfirmationPage';
import AdminDashboard from '@/pages/AdminDashboard';
import TermsPage from '@/pages/TermsPage';
// Services pages
import ServicesPage from '@/pages/services/ServicesPage';
import StudioRentalPage from '@/pages/services/StudioRentalPage';
import PhotoStudioPage from '@/pages/services/PhotoStudioPage';
import LiveStreamingPage from '@/pages/services/LiveStreamingPage';
import ContentRetreatPage from '@/pages/services/ContentRetreatPage';
import OnlineCoursePage from '@/pages/services/OnlineCoursePage';
import MobileKitPage from '@/pages/services/MobileKitPage';
import MonthlyPlansPage from '@/pages/services/MonthlyPlansPage';
import ServiceConfirmationPage from '@/pages/services/ServiceConfirmationPage';
import CustomPaymentPage from '@/pages/CustomPaymentPage';
// Service booking pages
import StudioRentalBooking from '@/pages/services/booking/StudioRentalBooking';
import PhotoStudioBooking from '@/pages/services/booking/PhotoStudioBooking';
import LiveStreamingBooking from '@/pages/services/booking/LiveStreamingBooking';
import ContentRetreatBooking from '@/pages/services/booking/ContentRetreatBooking';
import OnlineCourseBooking from '@/pages/services/booking/OnlineCourseBooking';
import MobileKitBooking from '@/pages/services/booking/MobileKitBooking';
import MonthlyPlansBooking from '@/pages/services/booking/MonthlyPlansBooking';

function AppContent() {
  const location = useLocation();
  // Hide header on admin page
  const showHeader = !location.pathname.startsWith('/aa');
  
  return (
    <>
      <ScrollToTop />
      {showHeader && <Header />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/confirmation" element={<ConfirmationPage />} />
        <Route path="/aa" element={<AdminDashboard />} />
        <Route path="/terms" element={<TermsPage />} />
        {/* Services routes */}
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/studio-rental" element={<StudioRentalPage />} />
        <Route path="/services/photo-studio" element={<PhotoStudioPage />} />
        <Route path="/services/live-streaming" element={<LiveStreamingPage />} />
        <Route path="/services/content-retreat" element={<ContentRetreatPage />} />
        <Route path="/services/online-course-filming" element={<OnlineCoursePage />} />
        <Route path="/services/mobile-kit" element={<MobileKitPage />} />
        <Route path="/services/monthly-plans" element={<MonthlyPlansPage />} />
        <Route path="/services/confirmation" element={<ServiceConfirmationPage />} />
        <Route path="/custom-payment" element={<CustomPaymentPage />} />
        <Route path="/custom-payment/success" element={<CustomPaymentPage />} />
        {/* Service booking routes */}
        <Route path="/services/studio-rental/book" element={<StudioRentalBooking />} />
        <Route path="/services/photo-studio/book" element={<PhotoStudioBooking />} />
        <Route path="/services/live-streaming/book" element={<LiveStreamingBooking />} />
        <Route path="/services/content-retreat/book" element={<ContentRetreatBooking />} />
        <Route path="/services/online-course-filming/book" element={<OnlineCourseBooking />} />
        <Route path="/services/mobile-kit/book" element={<MobileKitBooking />} />
        <Route path="/services/monthly-plans/book" element={<MonthlyPlansBooking />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster 
        position="top-center"
        toastOptions={{
          style: {
            background: '#0D0D0D',
            color: '#ffffff',
            border: '1px solid #262626'
          }
        }}
      />
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;